<template>
  <div>
    <other-banner :BannerType="'新闻中心'"></other-banner>
    <div class="content_box">
      <div class="title">
        <title-nav :zhName="$route.name" :enName="$route.meta.cate"></title-nav>
      </div>
      <div class="cutr_content">
        <div class="news_tab">
          <div class="item_news" @click="changCase(2)" :class="{'active_news':case_index==2}">
            <span class="line" v-if="case_index==2"></span>
            <span>企业动态</span>
          </div>
          <div class="item_news" @click="changCase(1)" :class="{'active_news':case_index==1}">
            <span class="line" v-if="case_index==1"></span>
            <span>行业资讯</span>
          </div>
        </div>
        <div class="new_list">
          <div class="bo_news animate__animated animate__slow" :class="{'animate__fadeInUp':item.anmintes}"  @click="changDetails(item.id)" v-for="(item,index) in newList" :key="index">
           <div class="new_list_box">
             <div class="img_box">
               <img :src="item.cover">
             </div>
             <div class="contents">
               <div class="title_name one-txt-line">{{item.title}}</div>
               <div class="intro many-txt-line">{{item.intro}}</div>
               <div class="bootom_ouy">
                 <div class="times">{{item.create_time}}</div>
                 <div class="more_detail">
                   <img src="../assets/news/detais.png">
                   <div>查看详情</div>
                 </div>
               </div>
             </div>
           </div>
            <div class="box_new_line"></div>
          </div>
        </div>
        <div class="block_pagination block_pc" v-if="total">
          <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-size="6"
              :pager-count="7"
              layout="prev, pager, next, total,jumper"
              :total="total">
          </el-pagination>
        </div>
        <div class="block_pagination block_wap" v-if="total">
          <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-size="6"
              :pager-count="5"
              layout="prev, pager, next"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import OtherBanner from "../components/otherBanner";
import TitleNav from "../components/titleNav";
import {getNewsList} from "../api/apis";

export default {
  name: "product",
  components: {TitleNav, OtherBanner},
  data(){
    return{
      newList:[],
      case_index:2,
      page:1,
      total:0,
    }
  },
  mounted() {
    this.GetRecruitList()
    window.addEventListener('scroll', this.handleScroll);
  },
  methods:{
    handleScroll() {
      let scroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (document.body.clientWidth < 1200) {

      }else {
        if (scroll > 135) {
          if( this.newList[0]){
            this.newList[0].anmintes = true
          }
        }
        if (scroll > 384) {
          if( this.newList[1]){
            this.newList[1].anmintes = true
          }
        }
        if (scroll > 638) {
          if( this.newList[2]){
            this.newList[2].anmintes = true
          }
        }
        if (scroll > 890) {
          if( this.newList[3]){
            this.newList[3].anmintes = true
          }
        }
        if (scroll > 1136) {
          if( this.newList[4]){
            this.newList[4].anmintes = true
          }
        }
        if (scroll > 1384) {
          if( this.newList[5]){
            this.newList[5].anmintes = true
          }
        }
      }
    },
    changDetails(id){
      this.$router.push({path:'/newDetails',query:{detaisId:id}})
    },
    handleCurrentChange(e) {
      scrollTo(0,600)
      this.page = e
      // this.GetRecruitList()
      let datas = {type:this.case_index,page:this.page,limit:6}
      getNewsList(datas).then(res=>{
        res.data.data.map(item=>{
          item.anmintes = true
        })
        this.newList = res.data.data
        this.total = res.data.total
      })
    },
    changCase(e){
      this.case_index = e
      this.page = 1
      let datas = {type:this.case_index,page:this.page,limit:6}
      getNewsList(datas).then(res=>{
        res.data.data.map(item=>{
          item.anmintes = true
        })
        this.newList = res.data.data
        this.total = res.data.total
      })
    },
    GetRecruitList(){
      let datas = {type:this.case_index,page:this.page,limit:6}
      getNewsList(datas).then(res=>{
        res.data.data.map(item=>{
           item.anmintes = false
        })
        this.newList = res.data.data
        this.total = res.data.total
      })
    }
  }

}
</script>

<style scoped lang="less">
.content_box{
  width: 1200px;
  margin: 0 auto;
  cursor: pointer;
  .title{
    margin: 100px auto 30px;
  }
  .cutr_content {
    cursor: pointer;
    margin-top: 50px;
    margin-bottom: 160px;
    .news_tab{
      display: flex;
      align-items: center;
      justify-content: center;
      .item_news{
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #555555;
        display: flex;
        align-items: center;
          .line{
            display: inline-block;
            width: 26px;
            height: 0px;
            border: 4px solid #555555;
            opacity: 1;
            margin-right: 25px;
          }
      }
      .active_news{
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #555555;
      }
      .item_news:nth-child(1){
          margin-right: 164px;
      }
    }

    .new_list{
      margin-top: 60px;
      .bo_news{
        opacity: 0;
        margin-bottom: 41px;
        .new_list_box{
          //border-bottom: 1px solid #B4B4B4;
          display: flex;
          padding-bottom: 20px;
          .img_box{
            width: 271px;
            height: 191px;
            margin-right: 44px;
            img{
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .contents{
            width:844px;
            .title_name{
              width: 560px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #174567;
            }
            .intro{
              width: 777px;
              font-size: 17px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 32px;
              color: #666666;
              -webkit-line-clamp: 3;
              margin: 18px 0 20px;
            }
            .bootom_ouy{
              display: flex;
              align-items: center;
              justify-content: space-between;
              .times{
                font-size: 15px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
              }
              .more_detail{
                display: flex;
                align-items: center;
                font-size: 15px;
                font-family: MicrosoftYaHei;
                color: #FB0505;
                opacity: 0;
                transition: all 0.3s linear;
                img{
                  margin-right: 10px;
                  width: 20px;
                  height: 20px;
                }
              }
            }
          }
        }
        .box_new_line{
          width: 272px;
          height: 0px;
          border: 1px solid #B4B4B4;
          transition: all 0.3s linear;
        }
      }
    }
    .bo_news:hover{

      .new_list_box{
        .contents{
          .bootom_ouy{
            .more_detail{
              opacity: 1;
            }
          }
        }
      }
      .box_new_line{
        width: 1200px;
      }
    }
  }
  .block_wap {
    display: none;
  }

  .block_pc {
    display: block;
    margin: 100px auto 153px;
  }
}
@media (max-width: 1200px) {
  .content_box{
    width: auto;
    padding:0.1px 15px 0;
    .title{
      margin: 26px auto 11px;
    }
    .cutr_content {
      margin-top: 21px;
      margin-bottom: 80px;
      .news_tab{
        display: flex;
        align-items: center;
        justify-content: center;
        .item_news{
          font-size: 13px;
          .line{
            display: inline-block;
            width: 16px;
            height: 0px;
            border: 2px solid #555555;
            opacity: 1;
            margin-right:15px;
          }
        }
        .active_news{
          font-size: 22px;
        }
        .item_news:nth-child(1){
          margin-right: 91px;
        }
      }

      .new_list{
        margin-top: 49px;
        .bo_news{
          opacity: 1;
          margin-bottom: 15px;
          .new_list_box{
            //border-bottom: 1px solid #B4B4B4;
            display: flex;
            padding-bottom: 21px;
            .img_box{
              width: 111px;
              height: 78px;
              margin-right: 9px;
              img{
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .contents{
              width:226px;
              //width: 100%;
              .title_name{
                width: 100%;
                font-size: 11px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #174567;
              }
              .intro{
                width: 100%;
                font-size: 9px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 16px;
                color: #666666;
                -webkit-line-clamp: 2;
                margin: 11px 0 10px;
              }
              .bootom_ouy{
                display: block;
                align-items: center;
                justify-content: space-between;
                .times{
                  font-size: 10px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #666666;
                }
                .more_detail{
                  opacity: 0;
                  display: none;
                  //display: flex;
                  align-items: center;
                  font-size: 15px;
                  font-family: MicrosoftYaHei;
                  color: #FB0505;
                  opacity: 0;
                  transition: all 0.3s linear;
                  img{
                    margin-right: 10px;
                    width: 20px;
                    height: 20px;
                  }
                }
              }
            }
          }
          .box_new_line{
            width: 100%;
            height: 0px;
            border: 1px solid #B4B4B4;
            transition: all 0.3s linear;
          }
        }
      }
      .bo_news:hover{
        .new_list_box{
          .contents{
            .bootom_ouy{
              .more_detail{
                //opacity: 1;
                opacity: 0;
              }
            }
          }
        }
        .box_new_line{
          width: 100%;
        }
      }
    }

    .block_wap {
      display: block;
      margin: 40px auto 70px;
    }

    .block_pc {
      display: none;
    }
  }
}
</style>